import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { HandlerService } from '../handler.service';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { BottomSheet } from '../bottom.sheet';
import { MatBottomSheet } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-manage-role',
  templateUrl: './manage-role.component.html',
  styleUrls: ['./manage-role.component.scss'],
})
export class ManageRoleComponent  {
  loader: boolean = true;
  rolelist: any;
  orgObj: any;
  orgName;
  search;
  orgId:any = localStorage.getItem('organizationId');
  newOrgObject;
  orgs:any=[]
  constructor(public service: ApiService,
    public router: Router,
    public handler: HandlerService,
    public auth: AuthService,
    private bottomSheet: MatBottomSheet
    
      ) { }

    ionViewWillEnter() {
      this.service.getOrg().subscribe((res:any)=>{
        if(this.auth.checkCapability('FSA')){
          this.orgs=res;
        }else{
          this.orgs=res.filter(res=>{ return res.id==localStorage.getItem('organizationId')})
        }
        this.orgs.map(res=>{
          if(res.id == localStorage.getItem('organizationId')){
            this.orgName = res.name
          }
        })
      }, err => {
        this.handler.err(err);
      })
     
      this.getroles();
    }
  
    // getOrgs(){
    //   this.service.getOrg().subscribe((res:any)=>{
    //     this.orgs=res;
    //     .log(this.orgs)
    //   })
    // }

    getroles(){
      this.service.getAllRoles().subscribe(res => {
        if (res) {
          this.rolelist = res;
          this.loader = false;
        }else{
          this.rolelist = [];
          this.handler.res("No Data Found");
          this.loader = false;
        }
      }, err => {
        this.loader = false;
        this.handler.err(err)
      })
    }
  
    edit(id) {
      this.router.navigate(['/edit-role', id]);
    }
    openBottomSheetOrg(): void {
      const dialogRef = this.bottomSheet.open(BottomSheet, {
        data: this.orgs,
      });
      dialogRef.afterDismissed().subscribe((res) => {
        if(res){
        this.loader=true;
        this.orgName = res.name;
        localStorage.setItem('dashBoardOrgId',res.id)
        sessionStorage.setItem('orgId',res.id);
        this.getroles();
      }
       });
    }
    refreshData(event){
      this.loader = true; 
      this.ionViewWillEnter();
      setTimeout(() => {
        event.target.complete();
      }, 1000);
    }
  
    ionViewWillLeave(){
      sessionStorage.clear();
      this.rolelist=[];
      this.search = "";
      }

}
